// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { GetContentSearchApiParameter } from "@store/Framework/Services/ContentSearchService";
import ProductListState from "@store/Framework/Store/Starter/Pages/ProductList/ProductListState";
import { Draft } from "immer";

const initialState: ProductListState = {
    // currentTab cannot be set to products to prevent the mobius tab from flashing when f5 is pressed to reload the page
    getContentSearchApiParameter: {},
};

const actions = {
    "Starter/Pages/ProductList/UpdateSearchFields": (
        draft: Draft<ProductListState>,
        action: { parameter: GetContentSearchApiParameter & UpdateSearchFieldsType },
    ) => {
        const { type } = action.parameter;
        delete action.parameter.type;
        if (type === "Replace") {
            draft.getContentSearchApiParameter = action.parameter;
        } else if (type === "Initialize") {
            draft.getContentSearchApiParameter = {
                ...initialState.getContentSearchApiParameter,
                ...action.parameter,
            };
        } else {
            draft.getContentSearchApiParameter = {
                ...draft.getContentSearchApiParameter,
                ...action.parameter,
            };

            for (const key in draft.getContentSearchApiParameter) {
                const value = (<any>draft.getContentSearchApiParameter)[key];

                // remove empty parameters
                if (value === "" || value === undefined) {
                    delete (<any>draft.getContentSearchApiParameter)[key];
                }
            }

            for (const key in action.parameter) {
                // go back to page 1 if any other parameters changed
                if (
                    draft.getContentSearchApiParameter.cpage &&
                    draft.getContentSearchApiParameter.cpage > 1 &&
                    key !== "cpage" &&
                    key !== "cpageSize" &&
                    key !== "query" &&
                    key !== "currentTab"
                ) {
                    draft.getContentSearchApiParameter.cpage = 1;
                }
            }
        }
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type ProductListActions = Parameters<typeof reducer>[1];
export default reducer;
